import React, { useEffect, useLayoutEffect, useMemo } from 'react'
import i18n, { transformLanguageToAuth0Value } from 'translations/i18n'

import { Path } from 'constants/router'
import { StatusPage } from 'components/common/StatusPage'
import { logAnalyticsEvent } from 'utils/analytics'
import { useAuth0 } from 'utils/auth'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useUserStatus } from 'dataQueries'

const SignupMode: React.FC = () => {
  const { refreshUser, user, loginWithRedirect } = useAuth0()
  const navigate = useNavigate()
  const { t } = useTranslation(['email_verified', 'common'])

  const params = useMemo(() => new URLSearchParams(window.location.search), [])

  const userStatusRequest = useUserStatus()

  useEffect(() => {
    // we can redirect to index immediately if user email is verified
    if (user?.email_verified) return navigate(Path.INDEX)

    // After successful email verification wait 5s showing success info and redirect to login page in case Anonymous window or if user logout before entering to verification page. After that Onboarding form will be visible
    const timeoutId = window.setTimeout(() => {
      logAnalyticsEvent('initiates_login', { location: 'SignupMode' })
      return loginWithRedirect({
        appState: { targetUrl: Path.INDEX },
        authorizationParams: {
          mode: 'login',
          language: transformLanguageToAuth0Value(i18n.language),
          login_hint: params.has('userEmail') ? params.get('userEmail') ?? undefined : undefined,
        },
      })
    }, 5000)

    return () => window.clearTimeout(timeoutId)
  }, [user, navigate, loginWithRedirect, params])

  // handle user status
  useLayoutEffect(() => {
    if (
      userStatusRequest.isSuccess &&
      userStatusRequest.data?.isEmailVerified &&
      !user?.email_verified
    ) {
      refreshUser()
    } else if (
      (
        userStatusRequest.isSuccess ||
        userStatusRequest.isError
      ) &&
      !userStatusRequest.data?.isEmailVerified
    ) {
      window.setTimeout(() => {
        userStatusRequest.refetch()
      }, 500)
    }
  }, [user, refreshUser, userStatusRequest])

  return (
    <StatusPage
      title={t('title')}
      description={t('text')}
      primaryButton={{
        text: t('common:continue'),
        onClick: () => navigate(Path.INDEX)
      }}
    />
  )
}

export default SignupMode
